import { cn } from '../../utils/cn';

interface IArrowRightIconProps {
  className?: string;
  size?: number | string;
  width?: number | string;
  height?: number | string;
}

const ArrowRightIcon = ({
  className,
  size,
  width,
  height,
}: IArrowRightIconProps) => {
  const iconWidth = size || width || 24;
  const iconHeight = size || height || 24;

  const sizeClass =
    typeof size === 'number'
      ? `h-${size} w-${size}`
      : typeof size === 'string'
        ? size
        : 'h-4 w-4';

  return (
    <svg
      className={cn(sizeClass, className)}
      aria-hidden='true'
      xmlns='http://www.w3.org/2000/svg'
      width={iconWidth}
      height={iconHeight}
      fill='none'
      viewBox='0 0 24 24'
    >
      <path
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
        d='M19 12H5m14 0-4 4m4-4-4-4'
      />
    </svg>
  );
};

export default ArrowRightIcon;
